<template>
    <div class="schedule-list-container">
        <div class="flex items-center justify-between pb-5">
            <div class="text-lg font-medium main-text-color">{{ $t('widget.scheduleList') }}</div>
            <div>
                <schedule-form
                    :buttonLabel="$t('widget.addSchedule')"
                    icon="vc-icon-add"
                    :reportId="null"
                    @addedSchedule="addedSchedule"
                    :data="copyOfGetReportData"
                    :title="$t('widget.addSchedule')"
                    :create="create"
                    :reportData="reportData"
                    @pushDataInReportTrigger="pushDataInReportTrigger"
                />
            </div>
        </div>
        <div
            id="schedule-card"
            class="border-l-5 p-4 border-primary schedule-card-container"
        >
            <template v-if="reportLocalData.length">
                <schedule-form
                    icon="vc-icon-edit-pencil"
                    :reportId="null"
                    :data="reportData"
                    :dataToEdit="dataToEdit"
                    :title="$t('widget.editSchedule')"
                    :create="create"
                    hideButton
                    ref="schedule-form-to-edit"
                    @updateReportTriggerItem="updateReportTriggerItem"
                />
                <schedule-card
                    class="schedule-card-item"
                    v-for="(trigger, index) in reportLocalData"
                    :key="index"
                    actionsWithSchedule
                    :index="index"
                    :data="trigger"
                    :edit="edit"
                    :reportData="reportData"
                    @deleteScheduleItem="deleteScheduleItem"
                    :create="create"
                    @editItem="editItem"
                />
            </template>
            <template v-else>
                <div class="flex items-center justify-center flex-col w-full h-full pt-12">
                    <div>
                        <div class="no-data uppercase main-text-color">
                            {{ $t('general.noData') }}
                        </div>
                        <div class="flex items-center justify-center">
                            <schedule-form
                                :buttonLabel="$t('widget.addSchedule')"
                                :reportId="null"
                                showIcon
                                @addedSchedule="addedSchedule"
                                :data="copyOfGetReportData"
                                :title="$t('widget.addSchedule')"
                                :create="create"
                                :reportData="reportData"
                                @pushDataInReportTrigger="pushDataInReportTrigger"
                                class="schedule-list-form"
                            />
                        </div>
                    </div>
                    <div class="w-5/12 pt-4 flex items-center justify-center">
                        <img :src="getLogo"
                            alt="Logo"
                            class="opacity-10 h-full max-h-40 object-cover"
                        >
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { reportTriggerApi } from "@/modules/reports/services/reportTriggerService"
import { REPORT_TRIGGER_STATUS_ID_DISABLED } from '@/enum/reportStatuses'

export default {
    props: {
        edit: {
            type: Boolean,
            default: false
        },
        create: {
            type: Boolean,
            default: false
        },
        reportData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        ScheduleCard: () => import('@/modules/reports/components/ScheduleCard'),
        ScheduleForm: () => import('@/modules/reports/components/schedule/ScheduleForm.vue')
    },
    data () {
        return {
            dataToEdit: null
        }
    },
    computed: {
        copyOfGetReportData () {
            return cloneDeep(this.reportData)
        },
        reportLocalData () {
            return this.reportData.ReportTriggerList
        },
        getLogo() {
            return this.$store.getters['layout/getLogo']('activeLayout')
        }
    },
    methods: {
        addedSchedule () {
            this.$nextTick(() => {
                const element = document.getElementById('schedule-card')
                if (element) {
                    element.scrollTo({
                        top: element.scrollHeight,
                        behavior: 'smooth'
                    })
                }
            })
        },
        pushDataInReportTrigger (data) {
            if (this.edit) {
                this.reportData.ReportTriggerList.push(data)
            }
            this.$emit('pushDataInReportTrigger', data)
        },
        deleteScheduleItem (index) {
            if (this.edit) {
                const activeItem = this.reportData.ReportTriggerList[index]
                reportTriggerApi.reportTriggerChangeStatus({
                    ReportTriggerID: activeItem.ReportTriggerID,
                    ReportTriggerStatusID: REPORT_TRIGGER_STATUS_ID_DISABLED
                })
            }
            this.reportData.ReportTriggerList.splice(index, 1)
        },
        editItem (dataToEdit) {
            this.dataToEdit = dataToEdit.data
            this.$nextTick(() => {
                this.$refs['schedule-form-to-edit'].openModal()
            })
        },
        updateReportTriggerItem (data) {
            Object.keys(data.value).forEach((el => {
                this.reportData.ReportTriggerList[data.indexToEdit][el] = data.value[el]
            }))
            this.$emit('updateReportTriggerList', this.reportData.ReportTriggerList)
        }
    }
}
</script>

<style lang="scss" scoped>
.schedule-card-item:not(:last-child) {
    @apply mb-3;
}
.schedule-card-container {
    height: 100%;
    min-height: 350px;
    max-height: 350px;
    overflow-y: auto;

    border: 1px solid #BEC2C9;
    border-radius: 6px;
    background: var(--secondaryBgColor-color);
}
.schedule-list-container {
    @apply mt-18;
}
.report-schedule-data-no-data {
    height: 380px;
    border: 1px solid var(--gray-300);
    border-radius: 5px;
}
.no-data {
    font-weight: 700;
    font-size: 40px;
    line-height: 49px;
    color: var(--gray-700);
    margin-bottom: 18px;
}
.voicenter-text {
    fill: #2675FF !important;
    opacity: 0.1 !important;
}
</style>

<style lang="scss">
.schedule-list-form .schedule-add-button > span {
    @apply underline;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: var(--primary-color);
    text-decoration: underline;
}
</style>